import React from "react";

import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";

import { DefaultAndAuthAndOnelinkAndSubscriptionProps } from "model/props";

import { getLanguageString as _, stringExist } from "misc/lang";
import { ReactComponent as LogoWhiteSimplified } from "assets/images/onelinkto_logo_white_simplified.svg";
import { ReactComponent as LogoGreenSimplified } from "assets/images/onelinkto_logo_green_simplified.svg";
import Profile from "components/topmenu/Profile";
import { Pages, TopMenu as TopMenuItems } from "appConfig";
import { actionOpenCustomerPortal, useSignOut } from "misc/account_utils";
import css from "./topmenu.module.scss";

const onelinkIconWhite = (
  <Icon className={css.buttonIcon}>
    <LogoWhiteSimplified />
  </Icon>
);
const onelinkIconGreen = (
  <Icon className={css.buttonIcon}>
    <LogoGreenSimplified />
  </Icon>
);

const TopMenu: React.FC<DefaultAndAuthAndOnelinkAndSubscriptionProps> = (
  props
) => {
  const {
    loader,
    user,
    account,
    navigate,
    isSubscriptionOverDue,
    isCancelledAndOverFreeLimit,
    isSmallScreen,
  } = props;

  const signOut = useSignOut(props);

  return (
    <div className={css.topMenu}>
      {
        ////////////////////////////////////////////////////////////
        user && isSubscriptionOverDue && (
          <div className={css.errorBar}>
            <div className={css.left}>
              <span className={css.heading}>
                {_("payment", "errorbar_payment_overdue_title")}
              </span>{" "}
              {_("payment", "errorbar_payment_overdue_text")}
            </div>
            <div className={css.right}>
              <a
                href="#customerportal"
                className={css.actionLink}
                onClick={() => actionOpenCustomerPortal(user, loader)}
              >
                {_(
                  "payment",
                  isSmallScreen
                    ? "errorbar_payment_overdue_action_short"
                    : "errorbar_payment_overdue_action"
                )}
              </a>
            </div>
          </div>
        )
      }
      {
        ////////////////////////////////////////////////////////////

        user && isCancelledAndOverFreeLimit && (
          <div className={css.errorBar}>
            <div className={css.left}>
              <span className={css.heading}>
                {_("payment", "errorbar_cancelled_over_free_limit_title")}
              </span>{" "}
              {_("payment", "errorbar_cancelled_over_free_limit_text")}
            </div>
          </div>
        )
      }
      <div className={css.content}>
        <div
          className={css.logoWrapper}
          onClick={() => navigate(Pages.LANDING_PAGE)}
        >
          <LogoGreenSimplified />
        </div>

        <div className={css.subMenu}>
          {Object.keys(TopMenuItems).map((item) => {
            let text;

            if (isSmallScreen) {
              if (stringExist("topmenu", item + "_small"))
                text = _("topmenu", item + "_small");
            }

            if (!text) text = _("topmenu", item);

            return (
              <Link
                key={item}
                href={TopMenuItems[item].path}
                onClick={(event) => navigate(TopMenuItems[item], event)}
              >
                {text}
              </Link>
            );
          })}
        </div>

        {user && account && account.type !== "pending" && (
          <>
            <div className={css.subMenu}>
              <Button
                className={css.topMenuButton}
                component="span"
                onClick={() => navigate(Pages.MY_ONELINKS)}
                title={user.emailAddress || user.emailAddressPending}
                startIcon={isSmallScreen ? onelinkIconGreen : onelinkIconWhite}
                variant={isSmallScreen ? "text" : "contained"}
                color="primary"
                size="small"
              >
                {_(
                  "topmenu",
                  isSmallScreen ? "my_onelinks_short" : "my_onelinks"
                )}
              </Button>
              <Profile {...props} />
            </div>
          </>
        )}

        {!user && (
          <div className={css.subMenu}>
            <Button
              className={css.topMenuButton}
              component="span"
              onClick={() => navigate(Pages.SIGNIN)}
              variant={isSmallScreen ? "text" : "contained"}
              //variant="contained"
              color="primary"
              size={isSmallScreen ? "small" : "medium"}
            >
              {_("topmenu", "signin")}
            </Button>
            <Button
              className={css.topMenuButton}
              component="span"
              onClick={() => navigate(Pages.REGISTER)}
              variant={isSmallScreen ? "text" : "contained"}
              //variant="contained"
              color="primary"
              size={isSmallScreen ? "small" : "medium"}
            >
              {_("topmenu", "register")}
            </Button>
          </div>
        )}

        {user && account && account.type === "pending" && (
          <>
            <div className={css.subMenu}>
              {window.location.pathname !==
                Pages.COMPLETE_REGISTRATION.path && (
                  <Link
                    href={Pages.COMPLETE_REGISTRATION.path}
                    onClick={(event) =>
                      navigate(Pages.COMPLETE_REGISTRATION, event)
                    }
                  >
                    {_("topmenu", "continue_registration")}
                  </Link>
                )}
              <Link onClick={signOut}>{_("topmenu", "button_sign_out")}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TopMenu;
